import API from '.';

export default class City {
  /**
   * The fields from Cities
   * @param {string} locationCity Name of city.
   */
  constructor({ locationCity }) {
    this.locationCity = locationCity;
  }

  static async getCities(citySearch) {
    const api = await API();
    const { data } = await api.get(
      `/city/search?CountryId=${citySearch.CountryId}&CountrySubdivisionId=${
        citySearch.CountrySubdivisionId ? citySearch.CountrySubdivisionId : null
      }`
    );
    return data.map((d) => new City(d));
  }
}
